<app-loader [loader]="loader.count" *ngIf="loader.count > 0"></app-loader>

<app-header></app-header>

<div class="bg-container"
     [ngStyle]="{ 'background-image': catalogueService.getProperty('imageBackground') ? 'url(' + catalogueService.getProperty('imageBackground') + ')' : 'none' }">
  <div class="container contact">
    <h2 class="contact__title">{{ 'GENERAL_INFORMATION.TITLE' | translate }}</h2>
    <div class="contact-container">

      <div class="contact-container__left">

        <h3 class="contact__subtitle">{{ 'GENERAL_INFORMATION.EVENT_ADDRESS' | translate }}</h3>

        <div class="contact__address contact__address--gran-via">
          <svg class="pointer" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" [style.fill]="catalogueService.getProperty('mainColor')">
            <path d="M12 12C10.9 12 10 11.1 10 10C10 8.9 10.9 8 12 8C13.1 8 14 8.9 14 10C14 11.1 13.1 12 12 12ZM18 10.2C18 6.57 15.35 4 12 4C8.65 4 6 6.57 6 10.2C6 12.54 7.95 15.64 12 19.34C16.05 15.64 18 12.54 18 10.2ZM12 2C16.2 2 20 5.22 20 10.2C20 13.52 17.33 17.45 12 22C6.67 17.45 4 13.52 4 10.2C4 5.22 7.8 2 12 2Z" />
          </svg>
          <div class="contact__address-txt">
            <div class="address">Fira Barcelona Gran Vía</div>
            <div>Av. Joan Carles I, 64 - Halls 1 & 2</div>
            <div>08908 L'Hospitalet de Llobregat (Barcelona)</div>
            <div class="map-link pointer" (click)="goToMaps('granVia')">
              {{ 'GENERAL_INFORMATION.OPEN' | translate }}
              <img class="pointer" width="18" height="18" alt="map" src="assets/img/open_in_new_black.svg">
            </div>
          </div>
        </div>


        <h3 class="contact__subtitle">{{ 'GENERAL_INFORMATION.OFFICE_ADDRESS' | translate }}</h3>

        <div class="contact__address">
          <svg class="pointer" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" [style.fill]="catalogueService.getProperty('mainColor')">
            <path d="M12 12C10.9 12 10 11.1 10 10C10 8.9 10.9 8 12 8C13.1 8 14 8.9 14 10C14 11.1 13.1 12 12 12ZM18 10.2C18 6.57 15.35 4 12 4C8.65 4 6 6.57 6 10.2C6 12.54 7.95 15.64 12 19.34C16.05 15.64 18 12.54 18 10.2ZM12 2C16.2 2 20 5.22 20 10.2C20 13.52 17.33 17.45 12 22C6.67 17.45 4 13.52 4 10.2C4 5.22 7.8 2 12 2Z" />
          </svg>
          <div class="contact__address-txt">
            <div class="address">Fira Barcelona Montjuïc</div>
            <div>Avinguda Reina Mª Cristina s/n</div>
            <div>08004 Barcelona</div>
            <div class="map-link pointer" (click)="goToMaps('montjuic')">
              {{ 'GENERAL_INFORMATION.OPEN' | translate }}
              <img class="pointer" width="18" height="18" alt="map" src="assets/img/open_in_new_black.svg">
            </div>
          </div>
        </div>

        <div class="contact__phone">
          <svg class="pointer" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" [style.fill]="catalogueService.getProperty('mainColor')">
            <path d="M6.54 5C6.6 5.89 6.75 6.76 6.99 7.59L5.79 8.79C5.38 7.59 5.12 6.32 5.03 5H6.54ZM16.4 17.02C17.25 17.26 18.12 17.41 19 17.47V18.96C17.68 18.87 16.41 18.61 15.2 18.21L16.4 17.02ZM7.5 3H4C3.45 3 3 3.45 3 4C3 13.39 10.61 21 20 21C20.55 21 21 20.55 21 20V16.51C21 15.96 20.55 15.51 20 15.51C18.76 15.51 17.55 15.31 16.43 14.94C16.33 14.9 16.22 14.89 16.12 14.89C15.86 14.89 15.61 14.99 15.41 15.18L13.21 17.38C10.38 15.93 8.06 13.62 6.62 10.79L8.82 8.59C9.1 8.31 9.18 7.92 9.07 7.57C8.7 6.45 8.5 5.25 8.5 4C8.5 3.45 8.05 3 7.5 3Z" />
          </svg>
          <div>(+34) 932 332 000</div>
        </div>

        <div class="contact__email">
          <svg class="pointer" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" [style.fill]="catalogueService.getProperty('mainColor')">
            <path d="M22 6C22 4.9 21.1 4 20 4H4C2.9 4 2 4.9 2 6V18C2 19.1 2.9 20 4 20H20C21.1 20 22 19.1 22 18V6ZM20 6L12 11L4 6H20ZM20 18H4V8L12 13L20 8V18Z" />
          </svg>
          <div class="email">info@firabarcelona.com</div>
        </div>

      </div>

      <div class="contact-container__right">
        <h3 class="contact__subtitle">{{ 'GENERAL_INFORMATION.FAQ' | translate }}</h3>

        <div class="faq" [innerHTML]="utilsService._api(catalogueProperties['translations'], 'faq')"></div>

      </div>
    </div>
  </div>
</div>




<app-footer></app-footer>
